import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Components
import FontIcon from '../../../../../atoms/FontIcon';
var Close = /*#__PURE__*/function (_PureComponent) {
  _inherits(Close, _PureComponent);
  var _super = _createSuper(Close);
  function Close() {
    var _this;
    _classCallCheck(this, Close);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      var onClose = _this.props.onClose;
      e.stopPropagation();
      onClose();
    });
    return _this;
  }
  _createClass(Close, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer",
        onClick: this.handleClose,
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(FontIcon, {
        size: 16
      }, "icon-close"));
    }
  }]);
  return Close;
}(PureComponent);
Close.propTypes = {
  onClose: PropTypes.func
};
Close.defaultProps = {
  onClose: _noop
};
export default Close;